import React from "react";

import "./App.css";

function App() {
  // your bmi is 20.45
  // your suggested weight is between 50-67
  // you are in healthy weight range
  const [weight, setWeight] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const [bmi, setBmi] = React.useState(0);
  const [suggestedWeight, setSuggestedWeight] = React.useState(0);
  const [weightRange, setWeightRange] = React.useState(0);

  const calculateBmi = () => {
    const bmi = ((weight / (height * height)) * 10000).toFixed(2);
    setBmi(bmi);
    const temp = (height * height * bmi) / 10000;
    const suggestedWeight = parseInt(temp);
    setSuggestedWeight(suggestedWeight);
    const weightRange = suggestedWeight * 0.1;
    setWeightRange(weightRange);
  };

  return (
    <>
      <div
        className="flex flex-col h-screen items-center"
       
      
      >
        <h1
          className="text-2xl font-bold text-center

        px-44 py-2 bg-blue-500 text-white
        
        "
        >
          BMI Calculator
        </h1>
        <div
        className="flex flex-col items-center justify-center"
        >
          <label
            className="text-md

"
          >
            Enter your weight in kg
          </label>
          <input
            type="number"
            className="border-2 border-gray-400 rounded-md p-2

  "
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
          />
          <label
            className="text-md


"
          >
            Enter your height in cm
          </label>
          <input
            type="number"
            className="border-2 border-gray-400 rounded-md p-2"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
          />
          <button
            className="bg-blue-500 text-white rounded-md p-2 mt-4 mb-4 px-16
  "
            onClick={calculateBmi}
          >
            Submit
          </button>
          <div
          className="text-md pb-[52vh]
        "
        >
          <p>Your BMI is {bmi}</p>
          <p>
            Your suggested weight is between {suggestedWeight - weightRange}-
            {suggestedWeight + weightRange}
          </p>
          <p>You are in healthy weight range</p>
        </div>
        </div>
        <footer
          class="text-gray-600 body-font w-full
      "
        >
          <div
            class="bg-gray-100 pl-4 pr-4
         lg:pl-10 lg:pr-10
        "
          >
            <div class="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
              <p class="text-gray-500 text-sm text-center sm:text-left">
                © 2020 Saurav Hathi —
                <a
                  href="https://github.com/sauravhathi"
                  class="text-gray-600 ml-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @sauravhathi
                </a>
              </p>
              <span class="sm:ml-auto sm:mt-0 mt-2 sm:w-auto w-full sm:text-left text-center text-gray-500 text-sm">
                <a href="https://www.youtube.com/c/sauravhathi">YouTube</a>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default App;
